import React, { useState } from 'react';
import { DEFAULT_DATE_FORMAT } from '../../helpers/constants';
import moment from 'moment';
import { Button } from 'react-bootstrap';
import { CheckLg, Pencil, XLg } from 'react-bootstrap-icons';
import DatePicker from 'react-datepicker';

const EditAppartmentDates = ({ handleChange, fieldKey, value, className = '' }) => {
  const [editMode, setEditMode] = useState(false);
  const [date, setDate] = useState(value ? new Date(value) : null);

  const handleDateChange = newDate => {
    setDate(newDate);
  };

  const onSaveDate = () => {
    if (date) {
      handleChange(fieldKey, date?.toISOString());
    } else {
      handleChange(fieldKey, null);
    }
    setEditMode(false);
    setDate(null);
  };

  return (
    <div className={`d-flex w-100 justify-content-between align-items-center ${className}`}>
      {!editMode ? (
        <>
          <span className="mx-auto">{value ? moment(value).format(DEFAULT_DATE_FORMAT) : '-'}</span>
            <Button
              onClick={e => {
                e.stopPropagation();
                setEditMode(true);
                setDate(value ? new Date(value) : null);
              }}
              variant="transparent"
              className="text-success px-1 "
            >
              <Pencil size={10} />
            </Button>
        </>
      ) : (
        <div
          onClick={e => e.stopPropagation()}
          className="d-flex w-100 justify-content-between align-items-center gap-1"
        >
          <DatePicker
            portalId="root"
            selected={date}
            onChange={handleDateChange}
            isClearable={true}
            dateFormat="dd/MM/yyyy"
            wrapperClassName="d-block"
            className="form-control form-control-sm w-100 flex-grow-1 smallFont py-0"
          />
          <div className="d-flex gap-2">
            <Button
              onClick={e => {
                e.stopPropagation();
                onSaveDate();
              }}
              variant="transparent"
              className="text-success px-0 mx-0"
            >
              <CheckLg size={12} />
            </Button>
            <Button
              onClick={e => {
                e.stopPropagation();
                setEditMode(false);
              }}
              variant="transparent"
              className="text-danger px-0 mx-0"
            >
              <XLg size={12} />
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default EditAppartmentDates;
